import { Action, actionCreators } from "../actions";

interface Store {
    idleTs: number | undefined;
    isOffline: boolean;
}

function initialStore(): Store {
    return {
        idleTs: undefined,
        isOffline: true,
    };
}

export function update(store = initialStore(), action: Action): Store {
    switch (action.type) {
        case actionCreators.onIdle.type: {
            return { ...store, idleTs: Date.now() };
        }
        case actionCreators.onActive.type: {
            return { ...store, idleTs: undefined };
        }
        case actionCreators.onOffline.type: {
            return { ...store, isOffline: true };
        }
        case actionCreators.onOnline.type: {
            return { ...store, isOffline: false };
        }
        default: {
            return store;
        }
    }
}

export type OuterStore = { idle: Store };

export function getIdleTs(store: OuterStore) {
    return store.idle.idleTs;
}

export function getIsOffline(store: OuterStore) {
    return store.idle.isOffline;
}
